<template>
    <a-modal
        centered
        title="编辑标签"
        :visible="visible"
        :confirm-loading="submitting"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="420"
        :maskClosable="false"
        :after-close="after_close"
    >
        <div class="ids">已选择：{{ record.map((v) => v.markName).join("，") }}（共{{ record.length }}个商标）</div>

        <a-divider>选择标签</a-divider>

        <template slot="footer">
            <a-button :disabled="submitting" @click="on_cancel">取消</a-button>
            <a-button type="primary" :disabled="submitting" v-if="form.tag_ids.length" @click="on_add">添加到选中标签</a-button>

            <a-button v-if="!form.tag_ids.length" type="danger" :disabled="submitting" @click="on_remove_all">移出所有标签</a-button>

            <a-button v-if="form.tag_ids.length" type="danger" :disabled="submitting" @click="on_remove_selected">移出选中的标签</a-button>
        </template>
        <a-form-model :model="form">
            <a-checkbox-group v-model="form.tag_ids" class="b-checkbox">
                <div v-for="item in data_tags" :key="item.id">
                    <a-checkbox :value="item.id" class="checkbox">{{ item.name }}</a-checkbox>
                </div>
            </a-checkbox-group>
        </a-form-model>
    </a-modal>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    apply_nos: [],
                    tag_ids: [],
                    type: "add",
                },
                visible: false,
                callback: null,
                record: [],
                submitting: false,
            };
        },
        computed: {
            data_tags() {
                return this.$store.state.trademark_tags;
            },
        },
        created() {
            this.$event_bus.$on("trademark_tags_list", (record, callback) => {
                this.visible = true;
                this.record = record;
                this.callback = callback;

                this.form.apply_nos = this.record.map((v) => v.applyNo);
            });
        },
        methods: {
            on_remove_selected() {
                this.form.type = "remove";
                this.on_ok();
            },
            on_remove_all() {
                this.form.type = "remove_all";
                this.on_ok();
            },
            on_add() {
                this.form.type = "add";
                this.on_ok();
            },
            on_ok() {
                this.submitting = true;
                this.$http
                    .post("trademark/tags/move", this.form)
                    .then((response) => {
                        if (response.success) {
                            this.$message.success(response.message);
                            this.on_cancel();
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: response.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            on_cancel() {
                this.visible = false;
            },
            after_close() {
                this.form = {
                    apply_nos: [],
                    tag_ids: [],
                };
            },
        },
    };
</script>

<style lang="less" scoped>
    .ids {
        font-size: 12px;
    }
</style>
